var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduler-+-Profile-Association",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person-Scheduler---weekly-view-Copy",
    transform: "translate(-692.000000, -293.000000)",
    fill: "#EF5350",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(113.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/delete",
    transform: "translate(577.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,1.54666667 L9.5,2.66666667 L2.5,2.66666667 L2.5,1.54666667 L4.24398625,1.54666667 L4.76116838,1 L7.25085911,1 L7.76804124,1.54666667 L9.5,1.54666667 Z M2.99312715,9.88 L2.99312715,3.21333333 L9.00687285,3.21333333 L9.00687285,9.88 C9.00687285,10.1822237 8.90664476,10.4444433 8.70618557,10.6666667 C8.50572637,10.88889 8.26918808,11 7.99656357,11 L4.00343643,11 C3.73081192,11 3.49427363,10.88889 3.29381443,10.6666667 C3.09335524,10.4444433 2.99312715,10.1822237 2.99312715,9.88 Z",
    id: "delete"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.293eeead81dd50369c3cf6e23598c5af.svg";
export { ForwardRef as ReactComponent };